import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppLanguage = 'en' | 'so';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly STORAGE_KEY = 'hawdco_lang';

  private currentLangSubject = new BehaviorSubject<AppLanguage>(this.loadInitial());
  currentLang$ = this.currentLangSubject.asObservable();

  get current(): AppLanguage {
    return this.currentLangSubject.value;
  }

  setLanguage(lang: AppLanguage): void {
    this.currentLangSubject.next(lang);
    try {
      localStorage.setItem(this.STORAGE_KEY, lang);
    } catch {}
  }

  private loadInitial(): AppLanguage {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY) as AppLanguage | null;
      if (stored === 'en' || stored === 'so') {
        return stored;
      }
    } catch {}
    return 'en';
  }
}
